import Icon from '../components/Icon.vue'

Icon.register({
  meteor: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M511.3 20.8c-11.6 38.7-34.3 111.7-61.3 187.7 7 2.1 13.4 4 18.6 5.6 6.6 2 11.4 8.1 11.4 15.4 0 2.7-0.7 5.3-1.9 7.5-22.1 42.3-82.7 152.8-142.5 214.4-1 1.1-2 2.5-3 3.5-35.3 35.3-84 57.1-137.8 57.1-107.5 0-194.8-87.3-194.8-194.8 0-53.8 21.8-102.5 57-137.8 1-1 2.4-2 3.5-3 61.6-59.9 172-120.4 214.4-142.5 2.2-1.2 4.8-1.9 7.5-1.9 7.2 0 13.4 4.8 15.4 11.4 1.6 5.1 3.5 11.6 5.6 18.6 75.9-27 149-49.7 187.7-61.3 1.5-0.4 3.1-0.7 4.7-0.7 8.9 0 16.2 7.3 16.2 16.2 0 1.6-0.2 3.1-0.7 4.6zM320 320c0-70.6-57.4-128-128-128-70.6 0-128 57.3-128 128 0 70.6 57.3 128 128 128 70.6 0 128-57.3 128-128 0 0 0 0 0 0zM192 288c0 17.7-14.3 32-32 32-17.7 0-32-14.3-32-32 0-17.7 14.3-32 32-32h0c17.6 0 32 14.3 32 32 0 0 0 0 0 0v0zM224 368c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16c8.8 0 16 7.2 16 16v0z'
      }
    ]
  }
})
